<template>
      <transition name="fade">
            <div class="dialog-overlay" v-if="visible">
                  <div class="dialog-container">
                        <div class="dialog-header" v-html="title">
                        </div>
                        <div class="dialog-footer" v-if="showFooter">
                              <button class="confirmBtn" @click="handleConfirm" v-if="showConfirmButton">
                                    <div class="button-content" v-html="confirmText"></div>
                              </button>
                              <button class="cancelBtn" @click="handleCancel" v-if="showCancelButton">
                                    <div class="button-content" v-html="cancelText"></div>
                              </button>
                        </div>
                  </div>
            </div>
      </transition>
</template>

<script>
export default {
      props: {
            visible: {
                  type: Boolean,
                  default: false
            },
            title: {
                  type: String,
                  default: '提示'
            },
            showFooter: {
                  type: Boolean,
                  default: true
            },
            showCancelButton: {
                  type: Boolean,
                  default: true
            },
            showConfirmButton: {
                  type: Boolean,
                  default: true
            },
            cancelText: {
                  type: String,
                  default: '取消'
            },
            confirmText: {
                  type: String,
                  default: '确定'
            },
            closeOnClickOverlay: {
                  type: Boolean,
                  default: true
            }
      },
      methods: {
            handleClose() {
                  if (this.closeOnClickOverlay) {
                        this.visible = false;
                        this.$emit('close');
                  }
            },
            handleCancel() {
                  this.$emit('cancel');
                  this.handleClose();
                  console.log(this.visible,'visible')
            },
            handleConfirm() {
                  this.$emit('confirm');
                  this.handleClose()
                  console.log(this.visible,'visible')
            }
      }
};
</script>

<style scoped>
.dialog-overlay {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 99999;
      background-color: rgba(0, 0, 0, .7);
      display: flex;
      justify-content: center;
      align-items: center;
}

.dialog-container {
      background-color: #fff;
      border-radius: 4.27vw;
      box-shadow: 0 0.53vw 3.2vw 0 rgba(0, 0, 0, 0.1);
      width: 85.33vw;
      overflow: hidden;
}

.dialog-header {
      min-height: 24vw;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 4.53vw;
      text-align: center;
}

.dialog-body {
      padding: 5.33vw;
}

.dialog-footer {
      display: flex;
      overflow: hidden;
      user-select: none;
}

.dialog-footer button {
      flex: 1;
      height: auto;
      line-height: 6.4vw;
      min-height: 12.8vw;
      text-align: center;
      margin: 0;
      border: 0;
      background-color: #fff;
      width: 100%;
      border: 0.27vw solid #ebedf0;
}

.dialog-footer button::before {
      border: inherit;
      border-color: #000;
      border-radius: inherit;
}

.confirmBtn {
      color: #ee0a24;
}
</style>